.topic {
  margin-right: 5px;
}

.icon {
  position: relative;
  top: -2px;
  margin-right: 5px;
}
